<template>

  <section class="container" id="editcompany">
    
  <div class="backbutton">
    <div class="columns flex alignMiddle">
      <div class="column grow">
          <a href="#!" class="button" v-on:click="goBack">Zurück</a>
      </div>
    </div>
  </div>
    
    
    <div class="columns">
      <div class="column">
        <h1>Firma bearbeiten</h1>
      </div>
    </div>
    
    <div role="form" id="addcompanybox" autocomplete="off">

    <div class="columns flex alignTop">
      <div class="column half ">
    
            
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Firma" v-model="company"   autocomplete="nope">
                <label class="input-icon icon-company" for="company">Firma</label>                    
              </div>
            </div>          
            
    
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Straße und Nr." v-model="companyaddress"   autocomplete="nope">
                <label class="input-icon icon-address" for="companyaddress">Anschrift</label>                    
              </div>
            </div>
      
      
            <div class="field">
              <div class="control control-50">
                <input class="input" type="text" placeholder="Postleitzahl" v-model="companyzipcode"   autocomplete="nope">
                <label class="input-icon icon-address" for="companyzipcode">PLZ</label>                    
              </div>
              <div class="control control-50">
                <input class="input" type="text" placeholder="Stadt" v-model="companycity"   autocomplete="nope">
              </div>
            </div>

            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Land" v-model="companycountry"   autocomplete="nope">
                <label class="input-icon icon-flag" for="companycountry">Land</label>                    
              </div>
            </div>        
      
      </div>

  
      <div class="column half ">
      
            <div class="field">
              <div class="control control-100 with-icon">
                <input class="input" type="email" placeholder="E-Mail Adresse" v-model="companyemailaddress" id="companyemailaddress"   autocomplete="nope">
                <label class="input-icon icon-send" for="companyemailaddress">E-Mail</label>          
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100 with-icon">
                <input class="input" type="text" placeholder="Telefon" v-model="companyphonenumber" id="companyphonenumber"   autocomplete="nope">
                <label class="input-icon icon-phone" for="companyphonenumber">Telefon</label>          
              </div>
            </div>
           <div class="field">            
              <div class="control control-100 with-icon">
                <input class="input" type="text" placeholder="Fax" v-model="companyfaxnumber" id="companyfaxnumber"   autocomplete="nope">
                <label class="input-icon icon-fax" for="companyfaxnumber">Fax</label>          
              </div>
            </div>
      
            <div class="field">
              <div class="control control-100">
                <input class="input" type="text" placeholder="Website" id="companywebsite" v-model="companywebsite"   autocomplete="nope">
                <label class="input-icon icon-website" for="companywebsite">Website</label>                    
              </div>
            </div>          


        </div>
      </div>



      <div class="columns flex">
        <div class="column">
            <div class="field">
              <div class="control">
                <button type="submit" class="button is-link" v-on:click="saveCompany">Firma aktualisieren</button>
              </div>
            </div>
        </div>
      </div>



 
    </div><!-- /#form -->
  </section>
  
</template>
<script>
import firebase from 'firebase'
  
export default {
  name: 'EditCompany',
  data: function(){ 
    return {
          ref: null,
          company: '',          
          slug: null,
          companyaddress: null,
          companyzipcode: null,
          companycity: null,
          companyemailaddress: null,
          companyphonenumber: null,
          companyfaxnumber: null,
          companywebsite: null,
          companycountry: null,
      
    }
  },
  methods: {

    goBack: function(e){
      e.preventDefault();
      this.$router.go(-1)
    },


      saveCompany(){

              var updates = {              
                company: this.company,
                companyemailaddress: this.companyemailaddress,
                companyphonenumber: this.companyphonenumber,
                companyfaxnumber: this.companyfaxnumber,
                companywebsite: this.companywebsite,
                companyzipcode: this.companyzipcode,
                companycity: this.companycity,
                companyaddress: this.companyaddress,
                companycountry: this.companycountry,
                }

                this.ref.update(updates)
                    .then( (docRef) => {       
                        this.$swal({
                          title: 'Firma aktualisiert',
                          type: 'success',
                          showCancelButton: false,
                          confirmButtonText: 'OK und zurück'
                        }).then((result) => {
                          if (result.value) {
                            this.$router.push('/view-company/' + this.slug )
                          }
                        })                        
                      })
                      .catch(function (error) {
                        this.$swal('Das Aktualisieren ist fehlgeschlagen');                   
                      })

      },

  },
  mounted() {
          
        firebase.firestore().collection('contacts').where('slug', '==', this.$route.params.contact).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
                this.ref = doc.ref
                this.company = doc.data().company
                this.companyemailaddress = doc.data().companyemailaddress
                this.companyphonenumber = doc.data().companyphonenumber
                this.companyfaxnumber = doc.data().companyfaxnumber
                this.companyzipcode = doc.data().companyzipcode
                this.companycity = doc.data().companycity
                this.companyaddress = doc.data().companyaddress
                this.companycountry = doc.data().companycountry
                this.companywebsite = doc.data().companywebsite
                this.slug = doc.data().slug
            
          })
        
        })


      }  ,

  
    
}  
</script>
<style>
  #editcompany { padding: 5rem 0 0 0; }
  #editcompany .field { display: flex; padding: 0; }
  #editcompany .control { padding: 0.43333333em; display: flex; }
  #editcompany .control-33 { flex: 1 1 33.3333%; width: 33.3333%; max-width: 33.33333%; }
  #editcompany .control-50 { flex: 1 1 50%; width: 50%; max-width: 50%; }
  #editcompany .control-100 { flex: 0 0 100%; width:100%; max-width: 100%; align-items: stretch; }
  #editcompany .control input[type=text] { width: 100%; min-width: 10%; margin: 0; }
  #editcompany .control input[type=email] { width: 100%;  min-width: 10%; margin: 0; }
  #editcompany .control input { border-radius: 0 3px 3px 0; }
  #editcompany .input-icon { display: inline-block; background: #fff; height: 48px; width: 48px; min-width: 48px; border-radius: 3px 0 0 3px; line-height: 48px; }
  #editcompany .control input { order: 2; }
  #editcompany .control input-icon { order: 1; }
  #editcompany .control input:focus + .input-icon { border-color: #00aeff; }

  #editcompany .icon-company { background: url(../assets/icons/disc.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-phone { background: url(../assets/icons/phone.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-fax { background: url(../assets/icons/print.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-send { background: url(../assets/icons/envelope-alt.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcompany .icon-mobile { background: url(../assets/icons/iphone.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcompany .icon-address { background: url(../assets/icons/location.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }
  #editcompany .icon-website { background: url(../assets/icons/home-alt.svg) center center no-repeat; background-size: 1.6333333em; border: 1px solid #d9d9d8; border-right: 0; text-indent: -9999px; }

  #editcompany .control .iconafter#newcompany { display: inline-block; height: 48px; width: 48px; min-width: 48px; border: 0; line-height: 48px; order: 3; text-indent: -9999px; background: url(../assets/icons/add.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }

  #editcompany #addcompanybox .column { position: relative; }

</style>


// WEBPACK FOOTER //
// src/components/EditCompany.vue